/**
 * AwarenessLevelsTab — T26.
 * Workspace-wide library editor for 'awareness_level'.
 * Writers see this tab read-only (canWrite=false).
 * Admins and system_owners can write.
 */
import LibraryEditor from './LibraryEditor';

interface AwarenessLevelsTabProps {
  canWrite: boolean;
}

export default function AwarenessLevelsTab({ canWrite }: AwarenessLevelsTabProps) {
  return <LibraryEditor type="awareness_level" canWrite={canWrite} perProduct={false} />;
}
